var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AbstractRestService, identity, none, RestSettings } from '@gh/core-data';
import { SupplierUserProfileMapper } from './profiles.mapper';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-data";
var SupplierUserProfileRestService = /** @class */ (function (_super) {
    __extends(SupplierUserProfileRestService, _super);
    function SupplierUserProfileRestService(settings) {
        var _this = _super.call(this, settings) || this;
        _this.settings = settings;
        return _this;
    }
    SupplierUserProfileRestService.prototype.get = function () {
        return this.httpGet('/profiles/me', SupplierUserProfileMapper);
    };
    SupplierUserProfileRestService.prototype.update = function (profile) {
        return this.httpPut('/profiles', profile, identity(), SupplierUserProfileMapper);
    };
    SupplierUserProfileRestService.prototype.logout = function () {
        return this.httpGet('/profiles/logout', identity());
    };
    SupplierUserProfileRestService.prototype.acceptInvitation = function (officeId) {
        return this.httpGet("/profiles/accept-invitation/" + officeId, none());
    };
    SupplierUserProfileRestService.ɵfac = function SupplierUserProfileRestService_Factory(t) { return new (t || SupplierUserProfileRestService)(i0.ɵɵinject(i1.RestSettings)); };
    SupplierUserProfileRestService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierUserProfileRestService, factory: SupplierUserProfileRestService.ɵfac });
    return SupplierUserProfileRestService;
}(AbstractRestService));
export { SupplierUserProfileRestService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierUserProfileRestService, [{
        type: Injectable
    }], function () { return [{ type: i1.RestSettings }]; }, null); })();
